import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const en = {
  'tylers-fabrication': {
    sync: {
      local:        'Local Mode',
      localTitle:   'Working offline — changes save to this device only',
      cloud:        'Cloud Synced',
      cloudTitle:   'Connected to your account',
      syncing:      'Syncing…',
      syncingTitle: 'Saving changes to the cloud',
      error:        'Sync Error',
      errorTitle:   'Tap to retry — changes are queued locally',
    },
  },
  common: {
    actions: {
      cancel: 'Cancel',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources: { en },
    lng: 'en',
    fallbackLng: 'en',
    ns: ['tylers-fabrication', 'common'],
    defaultNS: 'tylers-fabrication',
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;
